import { useParams } from 'react-router-dom';

const allowedLangs = ['en', 'fr', 'es'];

// Langue a envoyer aux API. La langue de l'URL prime : a la premiere visite (navigation privee),
// localStorage est encore vide et navigator.language peut differer de la langue de la page, ce qui
// faisait repondre "introuvable" pour un evenement pourtant publie dans la langue de l'URL.
export const resolveLang = (urlLang?: string): string => {
    const fromUrl = (urlLang ?? '').toLowerCase();
    if (allowedLangs.includes(fromUrl)) return fromUrl;
    return (localStorage.getItem('lang') ?? navigator.language?.split('-')[0] ?? 'en').toLowerCase();
};

// Meme resolution, pour les composants rendus sous la route /:lang.
export const useResolvedLang = (): string => resolveLang(useParams<{ lang: string }>().lang);
